import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

function O2Loader(props) {
  var children = props.children,
      className = props.className,
      iconRight = props.iconRight,
      block = props.block,
      noResults = props.noResults,
      lazyTable = props.lazyTable,
      size = props.size,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "iconRight", "block", "noResults", "lazyTable", "size"]);

  var classes = classNames(className, "o2-loader", {
    "o2-loader--noresults": noResults,
    "o2-loader--lazytable": lazyTable
  });
  var elementClasses = classNames("o2-loader__element", size ? "o2-loader__element--" + size : false);
  var Tag = block ? "div" : "span";
  return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
    className: classes
  }), !lazyTable && /*#__PURE__*/React.createElement(React.Fragment, null, !iconRight && /*#__PURE__*/React.createElement(Tag, {
    className: elementClasses
  }), /*#__PURE__*/React.createElement(Tag, {
    className: "o2-loader__text"
  }, children), iconRight && /*#__PURE__*/React.createElement(Tag, {
    className: elementClasses
  })));
}

O2Loader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  iconRight: PropTypes.bool,
  block: PropTypes.bool,
  noResults: PropTypes.bool,
  lazyTable: PropTypes.bool,
  size: PropTypes.oneOf(["small", "big"])
};
export default O2Loader;